import { Navigate, Route, Routes } from "react-router-dom";

import { AdminRoute } from "@/app/AdminRoute";
import { Layout } from "@/app/Layout";
import { ProtectedRoute } from "@/app/ProtectedRoute";
import { AdminPage } from "@/pages/AdminPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { LoginPage } from "@/pages/LoginPage";
import { NewProjectPage } from "@/pages/NewProjectPage";
import { ProjectPage } from "@/pages/ProjectPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { RegisterPendingPage } from "@/pages/RegisterPendingPage";
import { SettingsKeysPage } from "@/pages/SettingsKeysPage";

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      {/* публичные */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/register/pending" element={<RegisterPendingPage />} />

      {/* защищённые */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/settings/keys" element={<SettingsKeysPage />} />
          <Route path="/projects/new" element={<NewProjectPage />} />
          <Route path="/projects/:id" element={<ProjectPage />} />
          {/* /projects list — Этап 9 (Dashboard) */}
        </Route>
      </Route>

      {/* админка */}
      <Route element={<AdminRoute />}>
        <Route element={<Layout />}>
          <Route path="/admin" element={<AdminPage />} />
        </Route>
      </Route>

      {/* старые ссылки → редирект на дашборд */}
      <Route path="/runs" element={<Navigate to="/" replace />} />
      <Route path="/runs/*" element={<Navigate to="/" replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
